<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<b-modal id="confirm-archive-modal" title="Archive creation warning" okTitle="Ok, proceed anyway" @ok.prevent="createArchive" size="lg">
  <p><strong>Warning</strong>: some of the nodes you selected require to be asynchronously retrieved before including them into an archive:</p>
  <p>
  <ul>
    <li v-for="node in notArchivableNodes" :key="node">{{node}}</li>
  </ul>
  </p>
  <p>If you proceed these files will be ignored and not included in the resulting archive file.</p>
</b-modal>
</template>

<script>
export default {
  name: 'ConfirmArchiveModal',
  computed: {
    notArchivableNodes() { return this.$store.state.selectedNotArchivableNodes }
  },
  methods: {
    createArchive() {
      this.$store.dispatch('createArchive')
        .then(() => {
          this.$bvModal.hide('confirm-archive-modal');
        });
    }
  }
}
</script>
